import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Split = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="split icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M9.00003 2V8.68629C9.00003 10.2776 8.36789 11.8037 7.24267 12.9289L3.08579 17.0858L1.7071 15.7071C1.07714 15.0772 0 15.5233 0 16.4142V22C0 22.5523 0.447715 23 1 23H6.58579C7.47669 23 7.92286 21.9229 7.29289 21.2929L5.91422 19.9142L10.0711 15.7574C10.8686 14.9598 11.5175 14.0414 12 13.0453C12.4825 14.0414 13.1314 14.9598 13.9289 15.7574L18.0858 19.9143L16.7071 21.2929C16.0772 21.9229 16.5233 23 17.4142 23H23C23.5523 23 24 22.5523 24 22V16.4142C24 15.5233 22.9229 15.0772 22.2929 15.7071L20.9142 17.0858L16.7573 12.9289C15.6321 11.8037 15 10.2776 15 8.68629V2H9.00003Z"
    />
  </svg>
)
